










































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";

@Component({
  components: { PersonAutoComplete },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class ReviewDnrSection extends Vue {
  @Prop({ default: () => [] }) reviews!: any[];
  @Prop({ default: false }) canAddReview!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  showForm = false;
  formValid = false;
  saving = false;
  statusOptions = ["DNR Berlaku", "DNR Dibatalkan"];

  form = {
    tanggal: localISODate(),
    status: "",
    keterangan: "",
    dokter_nama: "",
    dokter_id: null
  };

  async submit() {
    if (this.readOnly) return;
    this.saving = true;
    try {
      this.$emit("addReview", { ...this.form });
      this.showForm = false;
      this.form = {
        tanggal: localISODate(),
        status: "",
        keterangan: "",
        dokter_nama: "",
        dokter_id: null
      };
    } finally {
      this.saving = false;
    }
  }
}
